import Label from 'components/_parts/atoms/label';
import { memo, useMemo, lazy, Suspense } from 'react';

const ReactQuill = lazy(() => import('react-quill'));

function TextEditor({
  id,
  name,
  style,
  placeholder,
  defaultValue = '',
  validateMessage = '',
  ...props
}) {
  const memoError = useMemo(() => {
    if (validateMessage) {
      return <Label typeLabel="label_error">{validateMessage}</Label>;
    }
  }, [validateMessage]);
  const handleChange = (content, delta, source, editor) => {
    if (editor.getText() === '\n') {
      editor.setContents([]);
    }
    if (props.onChange) {
      props.onChange(content, delta, source, editor);
    }
  };
  return (
    <>
      <Suspense fallback={<div className="custom_text_editor" style={style}>Loading...</div>}>
        <ReactQuill
          className="custom_text_editor"
          theme="snow"
          name={name}
          id={id}
          defaultValue={defaultValue}
          placeholder={placeholder}
          style={style}
          onChange={handleChange}
          {...props}
        />
      </Suspense>
      {memoError}
    </>
  );
}

export default memo(TextEditor);
